export default __webpack_public_path__ + "static/media/ok_to_shop.0671ab29.png";